// extracted by mini-css-extract-plugin
export default {"container":"OrdersHistoryPage_container__ibk7b","empty":"OrdersHistoryPage_empty__ULG6y"};